export default "__VITE_ASSET__BI4BuII4__"